'use strict';

/* globals RELATIVE_PATH, config, $, config, utils, app */

require([
	RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js',
], function (Vue) {
	var internals = {};

	Vue.component('upload-component', {
		props: ['label', 'icon', 'onUploadSuccess'],
		data: function () {
			return {
				sharedData: {
					isUploading: false,
					progress: 0,
				}
			};
		},
		computed: {
			fileFormId: function () {
			  return 'fileForm-' + this._uid;
			},
			filesId: function () {
				return 'files-' + this._uid;
			  }
		},
		methods: {
			uploadFile: function () {
				internals.initUpload(this.filesId);
			},
		},
		mounted: function () {
			internals.element = this.$el;

			this.sharedData.fileFormId = this.fileFormId;
			this.sharedData.filesId = this.filesId;
			
			internals.onUpload(this.sharedData, this.onUploadSuccess);
		},
		template: '<div>' +
			'<form :id="fileFormId" method="post" enctype="multipart/form-data"><input type="file" :id="filesId" name="files[]" class="lt-ie9 hide" value="Upload"/></form>' +
			'<button class="btn btn-primary" type="button" v-on:click="uploadFile()">' +
				'<i :class="[sharedData.isUploading ? \'fa fa-spinner fa-spin\' : icon]" aria-hidden="true"></i> ' +
				'<span v-if="!sharedData.isUploading">{{label}}</span>' +
				'<span v-if="sharedData.isUploading">Uploading {{sharedData.progress}}%</span>' +
			'</button>' +
		'</div>',
	});

	internals.getFilesHandler = function (selector) {
		return $(selector);
	};

	internals.initUpload = function (filesId) {
		internals.getFilesHandler('#' + filesId).click();
	};

	internals.onUpload = function (sharedData, onSuccess) {
		internals.getFilesHandler('#' + sharedData.filesId).on('change', function (e) {
			var files = (e.target || {}).files || ($(this).val() ? [{ name: $(this).val(), type: utils.fileMimeType($(this).val()) }] : null);

			if (files) {
				internals.uploadContentFiles(sharedData, {
					files: files,
					route: '/api/post/upload',
					filename: $(this).val().replace(/^.*[\\/]/, ''),
				}, onSuccess);
			}
		});
	};

	internals.uploadContentFiles = function (sharedData, params, onSuccess) {
		var filesForm = internals.getFilesHandler('#' + sharedData.fileFormId);

		filesForm.attr('action', config.relative_path + params.route);

		filesForm.off('submit').submit(function () {
			sharedData.isUploading = true;
			sharedData.progress = 0;

			$(this).ajaxSubmit({
				headers: {
					'x-csrf-token': config.csrf_token,
				},
				resetForm: true,
				clearForm: true,
				formData: params.formData,
				data: { },

				error: function (xhr) {
					app.alertError(xhr.responseJSON.error);
				},

				uploadProgress: function (event, position, total, percent) {
					sharedData.progress = percent;
				},

				success: function (uploads) {
					onSuccess(uploads.response.images[0] || {}, params);
				},

				complete: function () {
					sharedData.isUploading = false;
				},
			});

			return false;
		});

		filesForm.submit();
	};
});

